import React from 'react'

const LearningMb = () => {
  return (
    <>
        <div className="learningjourneystages" data-aos-delay="400" data-aos="fade-up" data-aos-duration="2000">
            <div className="mycontinermb">
                <h4 className='subheading'>Learning Journey Stages</h4>
                <div className='text-center'>
                <img  src="./assets/images/Mobile/HomepageMb/learningJourney/learningjourneyimg.png" alt="" />

                </div>
            </div>
        </div>
    </>
  )
}

export default LearningMb